import { setWeekYear } from "date-fns";
import React from "react";
import { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { RoundCard, RunnerUpHeader } from "../../../ui";
import GeneralElectionToAssemblyConstituency from "./Tabs/GeneralElection_to_AssemblyConstituency";
import { tabs } from "./Tabs/Tabs";
import "./unitofficer.css";
import LeftMenu from "../../AnalyticsModule/Left";
import DownloadInstruction from "../../Dashboards/Dashboard/DownloadInstruction";
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";

const EpbPinUnitDownload = () => {
  const [defaultKey,setDefaultKey]=useState(1)
  const renderTabs = () => {
    switch (defaultKey) {
      case "1":
          return <GeneralElectionToAssemblyConstituency  constType={"AC"} electType={"GEN"}/>
      case "2":
          return <GeneralElectionToAssemblyConstituency  constType={"PC"} electType={"GEN"}/>
      case "3":
          return <GeneralElectionToAssemblyConstituency  constType={"AC"} electType={"BYE"}/>
      case "4":
          return <GeneralElectionToAssemblyConstituency  constType={"PC"} electType={"BYE"}/>
       default:
              return <GeneralElectionToAssemblyConstituency constType={"AC"} electType={"GEN"} />
    }
}
  return (
   <LeftMenu>
     <div className="ep-download">
       <div className="container box shadow ">
       <RunnerUpHeaderNew title={"e-PB Download"} />

        <Tabs
          id="uncontrolled-tab-example"
          className="mb-3 tab-list"
          activeKey={defaultKey}
          onSelect={(k) => setDefaultKey(k)}
        >
          {tabs.map((item) => (
            <Tab eventKey={item.key} title={item.label} >
              {}
            </Tab>
          ))}
        </Tabs>
        {renderTabs()}
      </div>
    </div>
    <DownloadInstruction />
   </LeftMenu>
  );
};

export default EpbPinUnitDownload;
